import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, createUnknownComponentVNode as _$cc, noop as _$no } from 'intact-vue-next';
import { makeStyles, kls } from './styles';
import { MemoBlock } from './memo';
import { getRestProps } from '../utils';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj, _style, _style2;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    mode = _this$get.mode;
  var _this$size = this.size,
    firstSize = _this$size.firstSize,
    lastSize = _this$size.lastSize;
  var _this$drag = this.drag,
    firstRef = _this$drag.firstRef,
    lastRef = _this$drag.lastRef,
    elementRef = _this$drag.elementRef,
    start = _this$drag.start,
    dragging = _this$drag.dragging;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-split"] = true, _classNameObj[k + "-" + mode] = true, _classNameObj[makeStyles(k)] = true, _classNameObj[[k + "-first-auto"]] = firstSize.value === 'auto', _classNameObj[[k + "-last-auto"]] = lastSize.value === 'auto', _classNameObj[[k + "-resizing"]] = dragging.value, _classNameObj);
  var stylePropName = mode === 'horizontal' ? 'width' : 'height';
  return _$cv('div', _extends({
    'className': _$cn(classNameObj),
    'ref': elementRef
  }, getRestProps(this)), [_$ce(2, 'div', _$cc(MemoBlock, {
    'block': $blocks.first,
    'children': (_$blocks['first'] = function ($super) {
      return null;
    }, __$blocks['first'] = function ($super, data) {
      var block = $blocks['first'];
      var callBlock = function callBlock() {
        return _$blocks['first'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['first'](_$no))
  }), 2, _$cn(kls('first', k)), {
    'style': (_style = {}, _style[stylePropName] = firstSize.value, _style)
  }, null, firstRef), _$ce(2, 'div', (_$blocks['drag'] = function ($super) {
    return _$ce(2, 'div', _$ce(2, 'div', null, 1, _$cn(kls('drag-lines', k))), 2, _$cn(kls('line', k)));
  }, __$blocks['drag'] = function ($super, data) {
    var block = $blocks['drag'];
    var callBlock = function callBlock() {
      return _$blocks['drag'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['drag'](_$no)), 0, _$cn(kls('line-wrapper', k)), {
    'ev-mousedown': start
  }), _$ce(2, 'div', _$cc(MemoBlock, {
    'block': $blocks.last,
    'children': (_$blocks['last'] = function ($super) {
      return null;
    }, __$blocks['last'] = function ($super, data) {
      var block = $blocks['last'];
      var callBlock = function callBlock() {
        return _$blocks['last'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['last'](_$no))
  }), 2, _$cn(kls('last', k)), {
    'style': (_style2 = {}, _style2[stylePropName] = lastSize.value, _style2)
  }, null, lastRef)]);
}
;